var _regeneratorRuntime = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var util = require("util");

var q = require('q');

var Fetcher = require("./NodeHttpFetcher.js");

var N3 = require('n3');

var RDFXMLParser = require('rdfxmlprocessor');

var _require = require('xmldom'),
    DOMParser = _require.DOMParser;

var JsonldToRDF = require('./JsonldToRDF');

var RDFaToRDF = require('./RDFaToRDF');

var NodeHTMLParser = require('./NodeHTMLParser');

var jsonld = require('jsonld');

var DataFactory = require('@rdfjs/data-model');

var EventEmitter = require('events');
/** This is the common part for both browser and NodeJS */


module.exports =
/*#__PURE__*/
function (_EventEmitter) {
  "use strict";

  _inherits(_class, _EventEmitter);

  function _class(options) {
    var _this;

    _classCallCheck(this, _class);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this));
    _this.prefixes = {}; //We like quads, so preference to serializations that we can parse fast with quads
    //Then comes JSON-LD, which is slower to parse
    //Then comes rdf/xml, turtle and n-triples, which we support in a fast manner, but it doesn’t contain named graphs
    //We also support HTML, but that’s really slow
    //We also support N3 and parse it quite fast, but we won’t do anything special with the N3 rules, so put it to low q

    var accept = 'application/trig;q=1.0,application/n-quads,application/ld+json;q=.9,application/rdf+xml;q=.8,text/turtle,application/n-triples';

    if (options && options.headers) {
      _this.fetcher = new Fetcher(accept, options.headers);
    } else {
      _this.fetcher = new Fetcher(accept);
    } //forward events on this class


    _this.fetcher.on("cache-miss", function (obj) {
      _this.emit("cache-miss", obj);
    });

    _this.fetcher.on("cache-hit", function (obj) {
      _this.emit("cache-hit", obj);
    });

    _this.fetcher.on("downloaded", function (obj) {
      _this.emit("downloaded", obj);
    });

    return _this;
  }

  _createClass(_class, [{
    key: "frame",
    value: function () {
      var _frame2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(triples, _frame) {
        var objects, graphs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, triple, obj;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof triples === 'string')) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return this.get(triples).then(function (response) {
                  return response.triples;
                });

              case 3:
                triples = _context.sent;

              case 4:
                objects = {
                  "@graph": []
                };
                graphs = {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 9;

                for (_iterator = triples[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  triple = _step.value;

                  //Json-LD lib uses underscores when blanknode
                  if (triple.subject.termType === 'BlankNode') {
                    triple.subject.value = '_:' + triple.subject.value;
                  }

                  if (triple.predicate.termType === 'BlankNode') {
                    triple.predicate.value = '_:' + triple.predicate.value;
                  }

                  if (triple.object.termType === 'BlankNode') {
                    triple.object.value = '_:' + triple.object.value;
                  }

                  if (triple.graph.termType === 'BlankNode') {
                    triple.graph.value = '_:' + triple.graph.value;
                  }

                  if (triple.graph.value && !graphs[triple.graph.value]) graphs[triple.graph.value] = {
                    "@id": triple.graph.value,
                    "@graph": []
                  };
                  obj = {
                    "@id": triple.subject.value
                  };

                  if (triple.object.termType === 'Literal') {
                    obj[triple.predicate.value] = {
                      "@value": triple.object.value
                    };
                    if (triple.predicate.language) obj[triple.predicate.value]["@language"] = triple.object.language;
                    if (triple.object.datatype) obj[triple.predicate.value]["@type"] = triple.object.datatype.value;
                  } else if (triple.predicate.value === 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type') {
                    obj["@type"] = triple.object.value;
                  } else {
                    obj[triple.predicate.value] = {
                      "@id": triple.object.value
                    };
                  }

                  if (!triple.graph.value) {
                    objects["@graph"].push(obj);
                  } else {
                    graphs[triple.graph.value]["@graph"].push(obj);
                  }
                }

                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](9);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 17:
                _context.prev = 17;
                _context.prev = 18;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 20:
                _context.prev = 20;

                if (!_didIteratorError) {
                  _context.next = 23;
                  break;
                }

                throw _iteratorError;

              case 23:
                return _context.finish(20);

              case 24:
                return _context.finish(17);

              case 25:
                objects["@graph"].push(Object.values(graphs));
                return _context.abrupt("return", jsonld.frame(objects, _frame));

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 13, 17, 25], [18,, 20, 24]]);
      }));

      function frame(_x, _x2) {
        return _frame2.apply(this, arguments);
      }

      return frame;
    }()
  }, {
    key: "addPrefix",
    value: function addPrefix(prefix, uri) {
      this.prefixes[prefix] = uri;
    }
  }, {
    key: "getCacheStats",
    value: function getCacheStats() {
      return this.fetcher.getCacheStats();
    }
  }, {
    key: "get",
    value: function get(url) {
      var _this2 = this;

      this.emit('request', url);
      return this.fetcher.get(url).then(function (response) {
        if (url !== response.url) {
          _this2.emit('redirect', {
            'from': url,
            'to': response.url
          });
        }

        _this2.emit('response', response.url);

        var triples = [],
            prefixes = {},
            promise = q.defer();

        if (response.type === 'application/ld+json' || response.type === 'application/json') {
          var parser = new JsonldToRDF({
            documentIRI: response.url,
            factory: DataFactory
          });
          parser.parse(response.body, function (error, triple, newPrefixes) {
            _this2.emit('parsed', response.url);

            if (error) {
              promise.reject(error);
            } else if (triple) {
              triples.push(triple);
            } else {
              prefixes = Object.assign(_this2.prefixes, prefixes);
              promise.resolve({
                triples: triples,
                prefixes: prefixes,
                statusCode: response.statusCode,
                url: response.url
              });
            }

            if (newPrefixes) {
              prefixes = Object.assign(prefixes, newPrefixes);
            }
          });
          return promise.promise;
        } else if (response.type === 'text/html') {
          var promises = [];
          var promiseIndex = 0; //Parses extra JSON-LD snippets in the page

          var document = NodeHTMLParser(response.body, response.url); //In the browser, this is replaced with BrowserHTMLParser

          var jsonldscriptelements = document.querySelectorAll("script[type*='application/ld+json']");

          for (var index = 0; index < jsonldscriptelements.length; index++) {
            var tag = jsonldscriptelements[index]; //TODO: what if there is no textContent and there is an src tag instead? Should this be supported?

            promises[index] = q.defer();
            var newTriples = [];
            new JsonldToRDF({
              documentIRI: response.url
            }).parse(tag.textContent, function (error, triple, newPrefixes) {
              if (triple) {
                triples.push(triple);
              } else if (error) {
                //If there’s an error in this promise, just resolve it without anything else
                console.error('WARNING: an error was given while processing a JSON-LD snippet: ', error);
                promises[promiseIndex].resolve();
                promiseIndex++;
              } else {
                //Success! Let’s resolve it.
                promises[promiseIndex].resolve();
                promiseIndex++;
              }
            });
          } //Parses the RDFa


          var parser = new RDFaToRDF({
            documentIRI: response.url,
            factory: DataFactory
          });
          parser.parse(document, function (error, triple, newPrefixes) {
            _this2.emit('parsed', response.url);

            if (error) {
              promise.reject(error);
            } else if (triple) {
              triples.push(triple);
            } else {
              prefixes = Object.assign(_this2.prefixes, prefixes);
              promise.resolve();
            }

            if (newPrefixes) {
              prefixes = Object.assign(prefixes, newPrefixes);
            }
          });
          var promises2 = [promise].concat(promises).map(function (promise) {
            return promise.promise;
          });
          return q.all(promises2).then(function () {
            return {
              triples: triples,
              prefixes: prefixes,
              statusCode: response.statusCode,
              url: response.url
            };
          });
        } else if (["application/trig", "application/n-quads", "text/turtle", "application/n-triples", "text/n3"].indexOf(response.type.toLowerCase()) > -1) {
          //Parse N3, text/turtle, N-Quads, n-triples or trig
          var parser = new N3.Parser({
            documentIRI: response.url,
            factory: DataFactory
          });
          parser.parse(response.body, function (error, triple, newPrefixes) {
            _this2.emit("parsed", response.url);

            if (error) {
              promise.reject(error);
            } else if (triple) {
              triples.push(triple);
            } else {
              prefixes = Object.assign(prefixes, _this2.prefixes);
              promise.resolve({
                triples: triples,
                prefixes: prefixes,
                statusCode: response.statusCode,
                url: response.url
              });
            }

            if (newPrefixes) {
              prefixes = Object.assign(prefixes, newPrefixes);
            }
          });
        } else if (["application/rdf+xml"].indexOf(response.type.toLowerCase()) > -1) {
          //RDFXML
          var parser = new RDFXMLParser(); //both base and graphname to the response url

          parser.parse(new DOMParser().parseFromString(response.body), response.url, response.url, function (triple) {
            _this2.emit("parsed", response.url);

            if (triple) {
              triples.push(triple);
            } else {
              promise.resolve({
                triples: triples,
                statusCode: response.statusCode,
                url: response.url
              });
            }
          });
        } else {
          //No parser found -- TODO: let’s try any parser until we find triples! The fastest first, the slowest last.
          //Just resolve the promise
          promise.resolve({
            statusCode: response.statusCode,
            triples: triples,
            prefixes: prefixes,
            url: response.url,
            error: 'Cannot parse ' + response.type
          });
        }

        return promise.promise;
      });
    }
  }]);

  return _class;
}(EventEmitter);